import { Injectable } from '@angular/core';
import { UtilsManager } from 'src/app/managers/utils/utils.manager';
import { NotifierManager } from 'src/app/managers/notifier/notifier.manager';
import { Notifier } from 'src/app/enums/notifier/notifier.enum';
import { NotifierMessage } from 'src/app/enums/notifier/message/notifier.enum';
import { RequestManager } from 'src/app/managers/request/request.manager';
import { ErrorManager } from 'src/app/managers/error/error.manager';
import { User } from 'src/app/beans/login/user/user.bean';
import { Organization } from 'src/app/beans/organization/organization.bean';
import { Result } from 'src/app/beans/result/result.bean';
import { RequestError } from 'src/app/enums/network/request/error/requestError.enum';
import { OrganizationDetail } from 'src/app/beans/organization/organization.detail.bean';
import { Hub } from 'src/app/beans/hub/hub.bean';

@Injectable({
  providedIn: 'root'
})
export class OrganizationHandler
{
    constructor(
      private _utils    : UtilsManager    ,
      private _notifier : NotifierManager ,
      private _request  : RequestManager  ,
      private _error    : ErrorManager
    ) { }

    async list(token: string, enabled: number)
    {      
        if (!this._utils.checker().isValidText(token)) 
        {
          this._notifier.show( 
            Notifier.WARNING                  , 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        } 

        try
        {
          const response = await this._request.organization().list( token, enabled ).toPromise()

          if (this._error.hasError(response)){
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response ) 
          }

          return response as Organization[]
        }catch(error)
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async get(code: string)
    {          
      if (!this._utils.checker().isValidText(code)) 
      {
        this._notifier.show( 
          Notifier.WARNING                  , 
          NotifierMessage.INVALID_PASSWORD
        )
        return undefined
      } 

      try
      {
        const response: any = await this._request.organization().get( code ).toPromise()

        // if (this._error.hasError(response)){
        //   // MANAGE ERROR
        //   return this._error.handleCQWebapp ( response ) 
        // }
        
        if (!response || !response.object) return undefined

        return response.object as OrganizationDetail

      }catch(error)
      {        
        // this._error.handleNetwork ( error )  
        return undefined
      }
    }

    async getHub( hub: string ){

      if (!this._utils.checker().isValidText(hub)) 
      {
        this._notifier.show( 
          Notifier.WARNING                  , 
          NotifierMessage.INVALID_PASSWORD
        )
        return undefined
      } 

      try
      {
        const response: any = await this._request.organization().getHub( hub ).toPromise()

        if (this._error.hasError(response)){
          // MANAGE ERROR
          return this._error.handleCQWebapp ( response ) 
        }
        
        if (!response || !response.hub) return undefined

        return response.hub as Hub

      }catch(error)
      {        
        // this._error.handleNetwork ( error )  
        return undefined
      }
    }

    async detail(token: string, organizationId: number)
    {      

        if (!this._utils.checker().isValidText(token)) 
        {
          this._notifier.show( 
            Notifier.WARNING                  , 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        } 

        if (!this._utils.checker().isValidId(organizationId)) 
        {
          this._notifier.show( 
            Notifier.ERROR                , 
            NotifierMessage.INVALID_ORG_ID
          )
          return undefined
        }

        try
        {
          const response = await this._request.organization().detail( token, organizationId ).toPromise()

          if (this._error.hasError(response)){
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response ) 
          }

          return response

        }catch(error)
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async update(token: string, organization_detail: OrganizationDetail)
    {      

        if (!this._utils.checker().isValidText(token)) 
        {
          this._notifier.show( 
            Notifier.WARNING                  , 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        }

        if (!this._utils.checker().isValidId(organization_detail.id)) 
        {
          this._notifier.show( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_ORG_ID
          )
          return undefined
        }

        if (!this._utils.checker().isValidText(organization_detail.name)) 
        {
          this._notifier.show( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_ORG_NAME
          )
          return undefined
        }

        if (!this._utils.checker().isValidText(organization_detail.zipCode)) 
        {
          this._notifier.show( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_ORG_ZIPCODE
          )
          return undefined
        }

        if (!this._utils.checker().isValidText(organization_detail.billAddress)) 
        {
          this._notifier.show( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_ORG_ADDRESS
          )
          return undefined
        }

        if (!this._utils.checker().isValidText(organization_detail.billEmail)) 
        {
          this._notifier.show( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_ORG_EMAIL
          )
          return undefined
        }

        if (!this._utils.checker().isValidText(organization_detail.billPhone)) 
        {
          this._notifier.show( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_ORG_PHONE
          )
          return undefined
        }

        if (!this._utils.checker().isValidId(organization_detail.placeId)) 
        {
          this._notifier.show( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_ORG_PLACE_ID
          )
          return undefined
        }

        try
        {
          const response = await this._request.organization().update( token, organization_detail.id, JSON.stringify(organization_detail) ).toPromise()

          if (this._error.hasError(response)){
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response ) 
          }
          else 
          {
            this._notifier.show
            ( 
              Notifier.SUCCESS            , 
              NotifierMessage.OPERATION_OK
            )
            return response
          }
        }catch(error)
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }
}

